import { Activity, Gauge, Heart, HelpCircle, Zap } from "lucide-react";
import { ProgressInfoTooltip } from "./ProgressInfoTooltip";
import { PROGRESS_METRIC_EXPLANATIONS } from "./progressMetricExplanations";

export const SOURCE_BADGE_CONFIG = {
  measured: {
    label: "Measured",
    icon: Gauge,
    className: "bg-analytics-blue/20 text-analytics-blue border-analytics-blue/30",
    tooltipLabel: "Measured power",
    tooltipContent: PROGRESS_METRIC_EXPLANATIONS.measuredPower,
  },
  smart_trainer: {
    label: "Smart trainer",
    icon: Zap,
    className: "bg-analytics-purple/20 text-analytics-purple border-analytics-purple/30",
    tooltipLabel: "Smart trainer power",
    tooltipContent: PROGRESS_METRIC_EXPLANATIONS.smartTrainerPower,
  },
  estimated: {
    label: "Estimated",
    icon: Activity,
    className: "bg-analytics-amber/20 text-analytics-amber border-analytics-amber/30",
    tooltipLabel: "Estimated power",
    tooltipContent: PROGRESS_METRIC_EXPLANATIONS.estimatedPower,
  },
  unknown: {
    label: "Unknown",
    icon: HelpCircle,
    className: "bg-analytics-grey/20 text-dark-text-secondary border-analytics-grey/30",
    tooltipLabel: "Unknown power source",
    tooltipContent: PROGRESS_METRIC_EXPLANATIONS.unknownPowerSource,
  },
  heart_rate: {
    label: "Heart rate",
    icon: Heart,
    className: "bg-analytics-red/20 text-analytics-red border-analytics-red/30",
    tooltipLabel: "Heart rate load",
    tooltipContent: "Training load estimated from heart-rate data.",
  },
  duration: {
    label: "Duration fallback",
    icon: Activity,
    className: "bg-analytics-amber/20 text-analytics-amber border-analytics-amber/30",
    tooltipLabel: "Duration fallback",
    tooltipContent: PROGRESS_METRIC_EXPLANATIONS.durationFallback,
  },
};

export const getSourceBadgeConfig = (source) =>
  SOURCE_BADGE_CONFIG[source] || SOURCE_BADGE_CONFIG.unknown;

export const ProgressSourceBadge = ({
  source,
  showTooltip = false,
  testId,
  className = "",
}) => {
  const config = getSourceBadgeConfig(source);
  const Icon = config.icon;

  return (
    <span className="inline-flex items-center gap-1.5">
      <span
        className={`inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.2em] px-2 py-1 border ${config.className} ${className}`.trim()}
        data-testid={testId}
        data-source-type={source || "unknown"}
        aria-label={`Source: ${config.label}`}
      >
        <Icon className="w-3 h-3 shrink-0" strokeWidth={1.75} aria-hidden="true" />
        <span>{config.label}</span>
      </span>
      {showTooltip ? (
        <ProgressInfoTooltip
          label={config.tooltipLabel}
          content={config.tooltipContent}
          testId={testId ? `${testId}-tooltip` : undefined}
        />
      ) : null}
    </span>
  );
};
